<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!assistanceSelected) {
        <h1 class="title">Crear {{ termKey.AssistanceSingular | term }}</h1>
      }
    </div>
    <div class="title-color">
      @if (assistanceSelected) {
        <h1 class="title">Editar {{ termKey.AssistanceSingular | term }}</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="assistanceForm" (ngSubmit)="saveAssistance()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (assistanceForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (assistanceForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Población</mat-label>
              <input type="number" matInput placeholder="Población" formControlName="population" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ termKey.SectorSingular | term }}:</mat-label>

              <mat-select formControlName="sector" multiple>
                <input
                  class="searchInput"
                  matInput
                  [formControl]="searchControl"
                  placeholder="Buscar sector"
                  oninput="this.value = this.value.toUpperCase()"
                />
                @for (sector of listSector | searchfilter: searchControl.value; track sector.id) {
                  <mat-option [value]="sector.id">
                    {{ sector.name }}
                  </mat-option>
                }
              </mat-select>
              @if (assistanceForm.get('sector')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="soundingsourceSelected"
                [initialValue]="getSourceFoundingsValue()"
                placeholder="Seleccione una fuente de financiación"
                label="Fuente de financiacion"
                noResults="Sin resultados"
                (onSelectOption)="getSourceFoundingsSelected($event)"
              >
              </app-search-select>
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!assistanceForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
